import React from "react";
import { Upload } from "@phosphor-icons/react";

// Step 1 of the CSV wizard — file input + submit. Purely presentational;
// upload logic lives in the parent so the response can wire step 2.
export default function CsvUploadStep({ file, onFile, onSubmit, busy }) {
  return (
    <form onSubmit={onSubmit} className="brut-card mt-4 p-6 space-y-4" data-testid="wiz-step-1">
      <div>
        <label className="label-mono">CSV file*</label>
        <input data-testid="csv-file" type="file" accept=".csv"
          onChange={(e) => onFile(e.target.files?.[0] || null)}
          className="mt-1 block w-full file:border file:border-black file:px-3 file:py-1.5 file:mr-3 file:uppercase file:text-[11px] file:tracking-widest file:bg-white" />
        <div className="mt-2 text-xs text-zinc-600">
          First row must be a header. Column names can be anything — you&apos;ll map them in the next step.
        </div>
      </div>
      <button type="submit" data-testid="csv-preview" disabled={busy || !file}
        className="bg-black text-white border border-black px-4 py-2 uppercase text-xs tracking-widest font-bold hover:translate-x-[2px] hover:translate-y-[2px] hover:brut-shadow-sm transition-transform duration-100 disabled:opacity-60">
        {busy ? "Uploading…" : (<span><Upload size={12} className="inline mr-1" /> Upload &amp; preview</span>)}
      </button>
    </form>
  );
}
